<template>
  <div  class="profile-container container">
    <div class="profile-portrait">
      <div class="profile-portrait-container">
      <figure>
        <img src="../../assets/images/mishal-saeed.jpg" alt="Mishal Saeed">
          </figure>
        <div class="finger-print"><img src="@/assets/images/fingerprints/fingerprint-seven.svg" alt=""></div>
      </div>
    </div>
    <div class="profile-statement">

      <h2>Mishal Saeed</h2>
      <p class="job-title">Planning and Development Manager</p>

      <p>In my role I support the academic service planning processes which then have an impact on improving the staff and student experience. So that's like quite motivating for me to kind of support that. And the other thing that I quite enjoy are doing the lunch and learn sessions for Academic Services staff which I get a buzz out of getting people to be more informed about what's going on in the university because I work within my role like support by senior people within Academic Services, and I mean that in itself is quite inspiring just being able to like, you know, work with people who've got years and years of experience but also sharing that that experience with wider academic services through lunch and learn sessions.</p>

      <p>It's quite fun. And then finally, I think what I'd like to put in there, of the strategic projects that I get the opportunity to work on the stand directly, have an impact on improving the university experience, students and staff so I mean, could put examples in their best to keep it like that. give you examples, for example, such as having maybe having a consistent approach for programmes that start in January and does a project on that and I support this project manager. And that means that students who are joining us in January will get a similar experience to students who join us in September. So, this is actually, I just noticed this is very useful. Yeah, that's great. So so this thing could be edited. Yeah, right. I'll get back on.</p>

      <p>
        Yolande – 02:13
        what is something that you love about your cultural heritage?
      </p>

      <p>
        Mishal – 02:20
        I love my family and how supportive they are of my career, of my extracurricular activities, as well as just basically anything I want to do. There's a big family that I am a part of, and everybody looks after each other and everybody takes care of each other. And I think that's quite a special thing within my culture as it is in other cultures as well. I suppose that family to depend on this friends that you can count on. And I feel that that makes me excel professionally as well as within my personal goals. The other thing is the amount of discipline that my parents brought me up with, I now see that it has an impact on the way I work and how organised I am and some people comment on how organised I am and it's it goes back to how I was brought up. And I think the current thing, or just the morals and values that my parents have brought me up with, you know, they've taught me to be humble. They've taught me to be grateful, and they've always kind of encouraged me to work hard and you know, pursue what I'm passionate about. Trying to think of more cultural things. Food is another thing in my lungs that are a fantastic cook. She's in Pakistan at the moment, but when she's here, I don't eat out that I'm bringing lunch in my own lunch. And that's quite fun. I love the cultural events as well, such as Ramadan and eid just it brings people together with charity, charitable aspect of it as well. When you contribute to people who are unfortunate people who are in unfortunate circumstances as well as as well as the poor. So being involved in that is quite, quite a good feeling.
      </p>

      <p>
        Mishal Saeed – 04:34
        I think the biggest thing for me is that it's a family aspect of my culture, you inherited stuff. You know, that's that unit that support.
      </p>
      
      <button v-if="!showMore" @click="showMore = true" class="button is-large mb-6 show-more-btn">Show more</button>

      <div v-if="showMore === true">

      <p>
        Yolande – 05:17
        So, what does it look like to bring your whole self into work? I guess taken into account everything you just said. about family and food and bringing your lunch in.
      </p>

      <p>
        Mishal – 05:33
        For me, I think what that means is that it's not all about we're not I suppose what I was gonna say was, like, probably wouldn't be wanting to diverse. We're not factory workers. We're just in a line of you know, doing mechanical jobs. We are in a university with a lot of interconnected parts, projects, people working together and coordinating on different things. And so I'm quite interested in the fact that you get to share more than just what you're working on. You know, you get to talk about what you've been up to on the weekend. What are your plans for the evening, you know, what else are you doing? Aside from work because obviously, you're talking to work is the main topic but then what else is there? And it's quite interesting to share the things that I've been up to over the weekend. So do a lot of hiking, do a lot of Zumba. Have a lot of family time together, try new recipes and what's new films and TV shows and so a lot of extracurricular stuff basically, also volunteer in the community to view litter picks. You're in there, and just sharing what I do outside of work and the goals I've got, for example, fitness goals, like cycling, you know, staying active, eating healthy, that kind of stuff. For me, bringing my whole self means sharing that kind of Yeah, and learning about what other people are doing what places people are exploring and visiting. I love going for walks and hikes, I love exploring nature. Unusually, over the weekend, you know when the weather's nice I usually like to you place I get recommendations from people off work, give other people that's quite fun. So I think the only other thing I can think of is when there are cultural things happening like Ramadan and EAD, I just come to work in a sort of traditional form of fluids. Always submission like Muse which is a national dress and it's just for one day, you know, it would be that just because I'm at work, you know, what I'm wearing isn't going to impact me expected to
      </p>

      <p>
        Ebony 08:01
        that's really interesting. Yeah,
      </p>

      <p>
        Yolande – 08:03
        I think that's my word. Know, I think what you really said is really important that you're not just come in here to get the job done. And that's it. I don't talk about anything else. But that relational, the relational things that you do to help bond with other people and that would interconnect and how other people do their work as well. Yeah, so yeah, that's interesting, and I'm gonna get to walk
      </p>

      <p>
        Ebony – 08:37
        so the next question is how do you think Manchester net can best celebrate their black Asian and ethnic minority stuff and students? Important but also hard question.
      </p>

      <p>
        Mishal – 08:55
        Yeah, I think first thing what I would say is mmu is definitely Okay. Very good university for people from different backgrounds. And I've been at four different institutions and applying that admin system and there is real celebration of people from different backgrounds, and not just stuff that students has got, you know, basically, everybody feels welcome this real sense of community, which can be missing at other places.
      </p>

      <p>
        Mishal – 09:34
        So I think there's a lot of good stuff that my mentors that needed to keep doing and keep acknowledging and sharing what works like this campaign is really positive, obviously, but a lot of people don't know about it once it's out there by now. Thank we used to have a staff engagement week where you get to try different activities, even things that require a positive thing. It would be
      </p>

      <p>great that would come back. I remember playing badminton with others. It was kind of sessions like different things that you could do meeting sessions you know, different things, activities. one activity we would start with staff would go and do different sports sessions or just try new activities and</p>

      <p>
        Mishal – 10:30
        sports metrical triple A teams as well as University.
      </p>

      <p>
        Mishal – 10:37
        One of the things for people, for staff and students from diverse backgrounds is being able to have those opportunities where they can connect with other people. And for those opportunities that are you know, the better their experience will be relevant. What else can I say there? Because I think for staff definitely, just the the staff body can be more representative of the student population and the general population so definitely needs to be more diversity in the staff. In regards to the students, obviously, there is the there is the attainment gap that's there in every university and the university is doing what it can to a dress that it should be doing. Should basically keep keep trying to close as possible
      </p>

      <p>
        Yolande – 11:56
        and just be I mean the attainment gap. Other people would have said stuff about it as well. The IOC is all about this
        plugging in every dimension that we got,
      </p>

      <p>
        Mishal – 12:14
        so I'll just say what you know, I mean this is doing a lot for close it here we got the ILC is, but it's just such a complex problem that it just deserves all the resources to get his game but it's I guess it's just it'll take time in every university. Yes
      </p>

      <p>
        Yolande – 12:40
        And then the concluding question, what are you most proud of all?
      </p>

      <p>
        Mishal – 12:43
        In a work context, or it could be any
      </p>

      <p>
        Ebony – 12:44
        some students have spoken about, you know, their achievements in terms of academics or in their personal life. Yeah, I've only looked at the students so far, and a lot to do with their culture. One student is an international student. So actually, she was a teacher back in Singapore and has come over here to study physiotherapy that's an achievement and kind of bringing in culture to the university through the bame ambassadors. But yeah, there's varied answers. I would probably say myself if I was doing a testimonial or when I do mine I would say graduated in the height of the pandemic at this current moment in time, and yeah, like my family was part of at this time.
      </p>

      <p>
        Mishal – 14:15
        It's very good. I guess what I'll say to that question, is that I'm proud of the journey I've been on as a student as well as, as a staff member. As I've gradually kind of hit all my goals. So I finished my undergrad I did my masters
      </p>

      <p>during this period, I was actually president and yes,</p>

      <p>
        Ebony – 15:13
        So I guess you are proud of the journey that you’ve been on to get to where you are today.
      </p>

      <p>
        Mishal – 15:13
        Yes, that is a wonderful statement. I'll go with that. A lot over the head. You know, what awards been on the news, you know, becoming the counsellor later in, in a month's time, so that'll be something that'll be quite
      </p>

      <p>
        Mishal – 15:32
        a journey Wow, that is a journey.
      </p>

      <p>
        Yolande – 15:36
        That's fantastic. So what was your experience like being as SU president?
      </p>

      <p>
        Mishal – 15:40
        So I did my undergrad at Salford a few years ago. spent six years there so say for undergrad I did a placement year with the BBC, and then became vice president in su person. And I think for one year, I was quite an influential person in Salford. Not only was I elected kind of spokesperson for over 22,000 students, also organising TEDx conferences, as a volunteer, that then that we do win the heart of all for the world. And also got me an award from the Duke of Edinburgh when he visited Salford quiet golden period. To top that up, I thought okay, we'll do it. We'll do a Master's from the University of Oxford. And then after that period, I kind of hit a couple of obstacles and slow down a bit and then slightly rebuild myself again. Yeah. So you won't put all that in there I'm looking forward.
      </p>

      <p>
        Yolande – 17:05
        An inspiration wow
      </p>

      <p>
        Ebony - 17:14
        thank you so much for taking the time to come and be part of the campaign.
      </p>

      <p>
        Yolande – 17:19
        Yeah, we're looking forward to sharing this
      </p>

    </div>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/reactivity'
  export default {

    setup() {
      const showMore = ref(false)

      return { showMore }
    }

  }
</script>

<style lang="scss" scoped>

  .profile-container {
  flex-direction: row-reverse;
  }

  .profile-portrait-container {
    justify-content: flex-end;
  }

</style>